import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {BaseurlService} from '../../services/baseurl.service';

@Injectable({
  providedIn: 'root'
})
export class MozPlacesService {

  constructor(
    private http: HttpClient,
    private baseurlService: BaseurlService,
  ) { }

  getMozPlaces(): Observable<Page<MozPlacesEntity>> {
      return this.http.get<Page<MozPlacesEntity>>(`${this.baseurlService.getBaseUrl()}/mozPlaces?pageSize=10000`);
  }

  getMozPlacesFilters(): Observable<MozPlacesFilter[]> {
    return this.http.get<MozPlacesFilter[]>(`${this.baseurlService.getBaseUrl()}/mozPlaces/filters`);
  }

  addMozPlacesFilters(filter: string): Observable<MozPlacesFilter> {
    return this.http.post<MozPlacesFilter>(`${this.baseurlService.getBaseUrl()}/mozPlaces/filters`, {whiteList: filter});
  }

  deleteMozPlacesFilters(id: number): Observable<MozPlacesFilter> {
    return this.http.delete<MozPlacesFilter>(`${this.baseurlService.getBaseUrl()}/mozPlaces/filters/${id}`);
  }

  manualAck(id: number): Observable<void> {
    return this.http.post<void>(`${this.baseurlService.getBaseUrl()}/mozPlaces/manualAck/${id}`, {});
  }
}

export interface MozPlacesFilter {
  id: number;
  whiteList: string;
}

export interface MozPlacesEntity {
  id?: number;
  hostname: string;
  filename: string;
  sqliteId: number;
  createdAt: Date;
  updatedAt: Date;
  url?: string;
  title?: string;
  visitCount?: number;
  hidden?: boolean;
  typed?: boolean;
  frecency?: number;
  lastVisitDate?: Date;
  guid?: string;
  foreignCount?: number;
  urlHash?: number;
  description?: string;
  previewImageUrl?: string;
  siteName?: string;
}


export interface Page<T> {
  content: T[];
  totalPages: number;
  totalElements: number;
  last: boolean;
  size: number;
  number: number;
  sort: { property: string; direction: 'ASC' | 'DESC'}[];
  first: boolean;
  numberOfElements: number;
}
